document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const siteHeader = document.querySelector('.site-header');
  let isStuck = false;

  function updateHeaderState() {
    const scrolled = window.scrollY > 180;

    if (scrolled && !isStuck) {
      body.classList.add('is-stuck');
      siteHeader.classList.remove('bg-scheme-background/0');
      siteHeader.classList.add('bg-scheme-background');
      isStuck = true;
    } else if (!scrolled && isStuck) {
      body.classList.remove('is-stuck');
      siteHeader.classList.remove('bg-scheme-background');
      siteHeader.classList.add('bg-scheme-background/0');
      isStuck = false;
    }
  }

  window.addEventListener("scroll", updateHeaderState);

  requestAnimationFrame(updateHeaderState);

  // Observe class changes and fix any interference
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        // If it’s stuck but somehow bg-scheme-background/0 came back — remove it
        if (isStuck && siteHeader.classList.contains("bg-scheme-background/0")) {
          siteHeader.classList.remove("bg-scheme-background/0"); 
          siteHeader.classList.add("bg-scheme-background");
        }
        // If not stuck but somehow bg-scheme-background is there — remove it
        if (!isStuck && siteHeader.classList.contains("bg-scheme-background")) {
          siteHeader.classList.remove("bg-scheme-background");
        }
      }
    }
  });

  observer.observe(siteHeader, { attributes: true });
});


